// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function propsChangesArray(props: Record<string, any> | null) {
    const changes: unknown[] = [];
    if (props) {
        for (const key in props) {
            if (Object.prototype.hasOwnProperty.call(props, key)) {
                changes.push(props[key]);
            }
        }
    }
    return changes;
}
